import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class DebugInventoryMovePlanActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/InventoryMovePlan/InventoryMovePlanBrowser")
	}

	render() {
		return (
			<Activity 
				name="DebugInventoryMovePlan"
				RenderedComponent={this.RenderedComponent}
				context="DebugInventoryMovePlan"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(DebugInventoryMovePlanActivity)
